import React from 'react';
import { Outlet } from 'react-router-dom';
import { ApolloProvider } from '@/context/ApolloContext';
import ApolloDrawer from './ApolloDrawer';

function ApolloLayout() {
  return (
    <ApolloProvider>
      <div className="flex h-full relative">
        {/* Main content — Apollo page rendered via Outlet */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </div>

        {/* Persistent right drawer */}
        <ApolloDrawer />
      </div>
    </ApolloProvider>
  );
}

export default ApolloLayout;
